import { Container, Link, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { Account } from "library/accounts/types";

interface Props {
  text: string;
  account: Account;
}

export const StatementBanner = ({ text, account }: Props) => (
  <Container bg="secondary.lightBlue.t25" padding="4" testId="statement-banner">
    <Container bg="white" padding="6">
      <SvgInline name="statements-now-available" width="79" height="66" />
      <Stack gap="4">
        <Text as="h4" textStyle="heading5">
          Go paperless
        </Text>
        <Text>{text}</Text>
        <Text>
          Switch to online statements{" "}
          <Link
            href="/statement-preferences"
            state={{ account }}
            newTab={false}
          >
            here
          </Link>
          .
        </Text>
      </Stack>
    </Container>
  </Container>
);
